import { DataStore, useDataStore } from './DataStore';

type AppDataStoreState = {
  checkedCompIds: Set<string>;
};

const appDataStore = new DataStore<AppDataStoreState>({
  checkedCompIds: new Set(),
});

export const useCheckedCompIds = () => useDataStore(appDataStore, (s: AppDataStoreState) => s.checkedCompIds);

export const setCheckedCompIds = (ids: Set<string>) => {
  appDataStore.setState({ ...appDataStore.getSnapshot(), checkedCompIds: ids });
};

export const toggleCompId = (compId: string) => {
  const { checkedCompIds } = appDataStore.getSnapshot();
  const next = new Set(checkedCompIds);
  if (next.has(compId)) {
    next.delete(compId);
  } else {
    next.add(compId);
  }
  setCheckedCompIds(next);
};
